<div class="main-container">
      <div class="loading-overlay" [hidden]="!appState.loading">
        <img src="/assets/img/loading.gif" class="loading-gif" alt="Loading..." />
    </div>
    <app-header></app-header>
    <div class="page-container" id="page-container" *ngIf="!isMaintenance">
        <router-outlet></router-outlet>
    </div>
    <div class="maintenance-banner" *ngIf="!!isMaintenance">
        <div class="maintenance-card">
            <div class="icon">🛠️</div>
            <h1>Under Maintenance</h1>
        </div>
    </div>
    <app-footer></app-footer>
</div>